import * as preact from "preact";

import noderef from "../../../foundation/utils/noderef";

import styles from "./LoadingBar.module.css";

class LoadingBar extends preact.Component {
    constructor(props) {
        super(props);

        this.state = {
            stopRequested: false,
            backgroundColor: props.initialColor
        };

        this.colorIndex = 0;
    }

    animate() {
        const {
            running,
            colors,
            initialColor,
            duration,
            easing
        } = this.props;

        const { stopRequested } = this.state;

        if (!this.nodeRefs.bar || (!running && !stopRequested)) {
            return;
        }

        const backgroundColor = stopRequested ? initialColor : colors[this.colorIndex];

        const animation = this.nodeRefs.bar.animate([
            { transform: "scaleX(0)", backgroundColor },
            { transform: "scaleX(1)", backgroundColor }
        ], {
            duration,
            easing
        });

        animation.addEventListener("finish", () => {
            if (stopRequested) {
                this.colorIndex = 0;

                this.setState({
                    stopRequested: false,
                    backgroundColor
                });

                return;
            }

            this.colorIndex = (this.colorIndex + 1) % colors.length;
            this.setState({ backgroundColor });

            this.animate();
        });
    }

    componentDidMount() {
        if (this.props.running) {
            this.animate();
        }
    }

    componentDidUpdate(prevProps) {
        const { running } = this.props;

        if (prevProps.running && !running) {
            this.setState({
                stopRequested: true
            });
        } else if (!prevProps.running && running) {
            this.animate();
        }
    }

    render() {
        const { backgroundColor } = this.state;

        return (
            <div class={styles.loadingBar} style={{ backgroundColor }}>
                <div ref={noderef(this, "bar")}/>
            </div>
        );
    }
}

LoadingBar.defaultProps = {
    initialColor: "var(--snowman)",
    colors: ["var(--yellow)", "var(--orange)", "var(--peach)"],
    duration: 1100,
    easing: "cubic-bezier(0.165, 0.84, 0.44, 1.0)"
};

export default LoadingBar;
